import { BusEvent } from '@web/common';

export class AdminBoxSaleChangedBusEvent extends BusEvent {}
